import React, {FC} from "react";
import {Loader} from "components/Loader";

import {GenderEmoji, GenderName, getStyleForUserReviewTag, toStatusString, UserStatuses} from "enums";
import {toDateString} from "utils";
import {ModerationUser} from "interfaces";
import {AboutInTable} from "components/ModerationUsersTable/AboutInTable";
import {toStatusChangesReasonString} from "enums/UserStatusChangeReason";

interface Props {
    isLoadingMore: boolean
    users: ModerationUser[]
    onClick: (id: string) => void
}

export const ModerationUsersTable: FC<Props> = ({isLoadingMore, users, onClick}) => {
    return <div className="overflow-auto w-100 d-flex flex-column align-items-center mt-2">
        <Loader isLoading={isLoadingMore}/>
        <div className="w-75">
            <table className="table table-hover">
                <thead className="bg-white border-bottom">
                <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Фото</th>
                    <th scope="col">Информация</th>
                    <th scope="col">Теги</th>
                    <th scope="col">Гео</th>
                    <th scope="col">Описание</th>
                </tr>
                </thead>
                <tbody>
                {users.map(u => {
                    const photo = u.photos?.[0];
                    const reviewStatus = u.statusHistory ? u.statusHistory[u.statusHistory?.length - 1] : undefined;
                    return (
                        <tr key={u.id} onClick={() => onClick(u.id)} style={{cursor: 'pointer'}}>
                            <td><small>{u.id}</small></td>
                            <td className="flex flex-column" style={{width: 120}}>
                                {photo &&
                                    <div className="position-relative">
                                        <img
                                            key={photo.key}
                                            src={photo.image[0].link}
                                            alt={`Pic ${photo.key}`}
                                            style={{
                                                objectFit: 'cover',
                                                height: 100,
                                                width: 100
                                            }}
                                            className={`img-fluid d-block rounded`}
                                        />
                                        {u.photos && u.photos.length > 1 &&
                                            <span className="badge bg-dark position-absolute"
                                                  style={{right: -5, top: -5}}>+{u.photos.length - 1}</span>}
                                    </div>
                                }
                            </td>
                            <td>
                                <p style={{minWidth: 180}}>
                                    {u.name}, {u.age}
                                    <span title={GenderName[u.gender]} className="mx-1">{GenderEmoji[u.gender]}</span>
                                    {u.isVerified && <small title="Верифицирован">✅</small>}
                                    {u.hasPremium && <small title="Есть Premium">⭐</small>} <br/>
                                    {reviewStatus && <><small>{toStatusChangesReasonString(reviewStatus.reason)}</small><br/></>}
                                    <small>{toStatusString(u.status)} {u.statusHistory && u.status === UserStatuses.Banned ? u.statusHistory[u.statusHistory.length - 1].reason : ''}</small><br/>
                                </p>
                                <small>Регистрация: {u.registrationDate && toDateString(u.registrationDate, true)}</small><br/>
                                <small>Онлайн: {u.onlineDate && toDateString(u.onlineDate, true)}</small>
                            </td>
                            <td>
                                {u.reviewTags.slice(0, 6).map((tag, i) => {
                                        const style = getStyleForUserReviewTag(tag.tag);
                                        return <span key={u.id + tag + i}
                                                     className={`mx-1 badge ${style.bg} ${style.text}`} style={style.style}>
                                            #{tag.tag}
                                        </span>
                                    }
                                )}
                                {u.reviewTags.length > 6 &&
                                    <div className="badge bg-dark">+{u.reviewTags.length - 6}</div>}
                            </td>
                            <td>{u.countryFlag} {u.countryName}{u.city && <br/>}{u.city}</td>
                            <td><AboutInTable user={u}/></td>
                        </tr>)
                })}
                </tbody>
            </table>
        </div>
    </div>
}